<div class="p-2">
  <mat-card [ngClass]="{'public': lecture.public}">
    <ng-container *ngIf="!lecture.billing">
      <app-ribbon></app-ribbon>
    </ng-container>
      <mat-card-content>
        <a (click)="isApproved(lecture)" class="clickable txt-deco-none">
          <h4 class="overflow-hidden text-overfloew-ellipsis white-space-nowrap">{{ lecture.name }}</h4>
        </a>
        <div class="mt-4 pt-2">
          <img mat-card-avatar [src]="(lecture.ownerObservable | async)?.avatarUrl" class="rounded-circle">
          <span class="ml-2">{{ (lecture.ownerObservable | async)?.name }}</span>
          <app-lecture-enrollment-status *appAuthorize="'!'+lecture.owner" [lecture]="lecture">
            <ng-container not-enrolled>
              <button mat-icon-button>
                <mat-icon></mat-icon>
              </button>
              <app-lecture-enroll-button [lecture]="lecture" class="float-right">
                <button mat-icon-button>
                  <mat-icon>person_add</mat-icon>
                </button>
              </app-lecture-enroll-button>
            </ng-container>
            <ng-container not-approved>
              <button mat-icon-button disabled class="float-right">
                <mat-icon>person_add</mat-icon>
              </button>
            </ng-container>
          </app-lecture-enrollment-status>
          <app-lecture-edit-button [lecture]="lecture" *appAuthorize="lecture.owner" class="float-right">
            <button mat-icon-button>
              <mat-icon>mode_edit</mat-icon>
            </button>
          </app-lecture-edit-button>
        </div>
      </mat-card-content>
  </mat-card>
</div>



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/lecture-nav-item/lecture-nav-item.component.html